import React from 'react';
import {
	Datagrid,
	TextField,
	DateField,
	FunctionField,
	Filter,
	TextInput,
	SelectInput,
	DateInput,
	NullableBooleanInput,
	EditButton
} from 'react-admin';
import { Typography } from '@material-ui/core';
import TList from '../../components/wrapper/TList';
import { toApiDateTimeFormat, toJavaScriptDateFormat } from '../../components/helper/DateHelper';
import { countriesForSelection } from '../../i18n/en.js';
import PropTypes from 'prop-types';
import { coreWalletUserStatusForSelection, coreWalletVerificationLevelsForSelection } from './UserConstants';
import UserListActions from './UserListActions';

const UserFilter = ({ userStatusForSelection, verificationLevelsForSelection, ...props }) => (
	<Filter {...props}>
		<DateInput
			source="createdFrom"
			label="resources.users.filter.createdFrom"
			parse={value => toApiDateTimeFormat(value)}
			format={value => toJavaScriptDateFormat(value)}
		/>
		<DateInput
			source="createdTo"
			label="resources.users.filter.createdTo"
			parse={value => toApiDateTimeFormat(value)}
			format={value => toJavaScriptDateFormat(value)}
		/>
		<TextInput alwaysOn resettable label="resources.users.filter.emailLike" source="emailLike" />
		<TextInput resettable label="resources.users.filter.phoneNumberLike" source="phoneNumberLike" />
		<SelectInput
			resettable
			choices={countriesForSelection}
			source="nationCodeList"
			label="resources.users.filter.nationCodeList"
		/>
		<SelectInput
			resettable
			choices={userStatusForSelection}
			source="userStatusList"
			label="resources.users.filter.userStatusList"
		/>
		<SelectInput
			resettable
			choices={verificationLevelsForSelection}
			source="userVerificationLevels"
			label="resources.users.filter.userVerificationLevels"
		/>
		<TextInput alwaysOn resettable label="resources.users.filter.firstNameLike" source="firstNameLike" />
		<TextInput alwaysOn resettable label="resources.users.filter.lastNameLike" source="lastNameLike" />
		<DateInput
			source="dateOfBirthFrom"
			label="resources.users.filter.dateOfBirthFrom"
			parse={value => toApiDateTimeFormat(value)}
			format={value => toJavaScriptDateFormat(value)}
		/>
		<DateInput
			source="dateOfBirthTo"
			label="resources.users.filter.dateOfBirthTo"
			parse={value => toApiDateTimeFormat(value)}
			format={value => toJavaScriptDateFormat(value)}
		/>
		<TextInput resettable label="resources.users.filter.birthPlaceLike" source="birthPlaceLike" />
		<SelectInput
			resettable
			choices={countriesForSelection}
			source="birthCountry"
			label="resources.users.filter.birthCountry"
		/>
		<TextInput
			resettable
			label="resources.users.filter.primaryAddressCityLike"
			source="primaryAddressCityLike"
		/>
		<TextInput resettable label="resources.users.filter.primaryAddressZip" source="primaryAddressZip" />
		<SelectInput
			resettable
			choices={countriesForSelection}
			source="primaryAddressCountry"
			label="resources.users.filter.primaryAddressCountry"
		/>
		<TextInput resettable label="resources.users.filter.registrationSource" source="registrationSource" />
		<NullableBooleanInput source="isOnWatchList" label="resources.users.filter.isOnWatchList" />
	</Filter>
);

const UserList = ({ userStatusForSelection, verificationLevelsForSelection, ...props }) => (
	<TList
		{...props}
		title="Users"
		sort={{ field: 'creationDateTime', order: 'DESC' }}
		actions={<UserListActions />}
		filters={
			<UserFilter
				userStatusForSelection={userStatusForSelection}
				verificationLevelsForSelection={verificationLevelsForSelection}
			/>
		}
	>
		<Datagrid>
			<EditButton />
			<FunctionField
				source="primaryEmail"
				render={record =>
					record.primaryEmail || (
						<Typography component="span" color="textSecondary">
							{record.id}
						</Typography>
					)
				}
			/>
			<TextField source="primaryPhoneNumber" sortable={false} />
			<TextField source="firstName" />
			<TextField source="lastName" />
			<DateField source="creationDateTime" showTime />
			<TextField source="status" sortable={false} />
			<TextField source="verificationLevel" sortable={false} />
		</Datagrid>
	</TList>
);

UserList.propTypes = {
	userStatusForSelection: PropTypes.array.isRequired,
	verificationLevelsForSelection: PropTypes.array.isRequired
};
UserList.defaultProps = {
	userStatusForSelection: coreWalletUserStatusForSelection,
	verificationLevelsForSelection: coreWalletVerificationLevelsForSelection
};

export default UserList;
